import "core-js/modules/es.array.flat-map.js";
import "core-js/modules/es.array.unscopables.flat-map.js";
import { disposables as m } from '../../utils/disposables.js';
import { isIOS as u } from '../../utils/platform.js';
function d() {
  return u() ? {
    before: function before(_ref) {
      var r = _ref.doc,
        n = _ref.d,
        c = _ref.meta;
      function o(a) {
        return c.containers.flatMap(function (l) {
          return l();
        }).some(function (l) {
          return l.contains(a);
        });
      }
      n.microTask(function () {
        var s;
        if (window.getComputedStyle(r.documentElement).scrollBehavior !== "auto") {
          var t = m();
          t.style(r.documentElement, "scrollBehavior", "auto"), n.add(function () {
            return n.microTask(function () {
              return t.dispose();
            });
          });
        }
        var a = (s = window.scrollY) != null ? s : window.pageYOffset,
          l = null;
        n.addEventListener(r, "click", function (t) {
          if (t.target instanceof HTMLElement) try {
            var e = t.target.closest("a");
            if (!e) return;
            var _URL = new URL(e.href),
              f = _URL.hash,
              i = r.querySelector(f);
            i && !o(i) && (l = i);
          } catch (_unused) {}
        }, !0), n.addEventListener(r, "touchstart", function (t) {
          if (t.target instanceof HTMLElement) if (o(t.target)) {
            var e = t.target;
            for (; e.parentElement && o(e.parentElement);) e = e.parentElement;
            n.style(e, "overscrollBehavior", "contain");
          } else n.style(t.target, "touchAction", "none");
        }), n.addEventListener(r, "touchmove", function (t) {
          if (t.target instanceof HTMLElement) {
            if (t.target.tagName === "INPUT") return;
            if (o(t.target)) {
              var e = t.target;
              for (; e.parentElement && e.dataset.headlessuiPortal !== "" && !(e.scrollHeight > e.clientHeight || e.scrollWidth > e.clientWidth);) e = e.parentElement;
              e.dataset.headlessuiPortal === "" && t.preventDefault();
            } else t.preventDefault();
          }
        }, {
          passive: !1
        }), n.add(function () {
          var e;
          var t = (e = window.scrollY) != null ? e : window.pageYOffset;
          a !== t && window.scrollTo(0, a), l && l.isConnected && (l.scrollIntoView({
            block: "nearest"
          }), l = null);
        });
      });
    }
  } : {};
}
export { d as handleIOSLocking };